import React ,{ useState ,useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../Style/blogDetails.css";
import NavsList from "./NavsList";
import { cutText, MyComponent, scrollToTop } from "./Methods";
import Comment from "./Comment";

export default function BlogDetails(){
    const navigate = useNavigate();
    const params = useParams();
    const [loading,setLoading] = useState(true);
    const [data,setData] = useState({});
    const firstLoad = useRef(true);
    useEffect(() => {
        if(!params.name){
            navigate("/");
        }
        scrollToTop();
        if(firstLoad.current){
            firstLoad.current = false;
            fetchData();
        }
        // setTimeout(() => {
        //     setData({        
        //         cover : "/image/blogCover.jpg",
        //         title : "عنوان مقاله نمایشی",
        //         shortDesc : "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک است، ",
        //         date : "1402/06/08",
        //         visit : 150,
        //         commentNumber : 5,
        //         description : "<p>گوشی‌های شیائومی به‌دلیل قیمت مقرون‌به‌صرفه در کنار ارائه‌ی قابلیت‌های جذاب، طی سال‌های اخیر محبوبیت زیادی بین کاربران ایرانی پیدا کرده‌اند. بسیاری از گوشی‌های شیائومی به‌لطف نمایشگر‌های کم‌حاشیه، متریال و کیفیت ساخت مناسب و پردازنده‌های پرقدرت حالا بیش‌ از هر وقت دیگری برای مدل‌های سامسونگ خط‌ونشان می‌کشند تا بیش‌از‌پیش دست برند محبوب کُره‌ای را از سبد خرید کاربران ایرانی کوتاه کنند.</p><p>گوشی‌های شیائومی به‌دلیل قیمت مقرون‌به‌صرفه در کنار ارائه‌ی قابلیت‌های جذاب، طی سال‌های اخیر محبوبیت زیادی بین کاربران ایرانی پیدا کرده‌اند. بسیاری از گوشی‌های شیائومی به‌لطف نمایشگر‌های کم‌حاشیه، متریال و کیفیت ساخت مناسب و پردازنده‌های پرقدرت حالا بیش‌ از هر وقت دیگری برای مدل‌های سامسونگ خط‌ونشان می‌کشند تا بیش‌از‌پیش دست برند محبوب کُره‌ای را از سبد خرید کاربران ایرانی کوتاه کنند.</p><p>گوشی‌های شیائومی به‌دلیل قیمت مقرون‌به‌صرفه در کنار ارائه‌ی قابلیت‌های جذاب، طی سال‌های اخیر محبوبیت زیادی بین کاربران ایرانی پیدا کرده‌اند. بسیاری از گوشی‌های شیائومی به‌لطف نمایشگر‌های کم‌حاشیه، متریال و کیفیت ساخت مناسب و پردازنده‌های پرقدرت حالا بیش‌ از هر وقت دیگری برای مدل‌های سامسونگ خط‌ونشان می‌کشند تا بیش‌از‌پیش دست برند محبوب کُره‌ای را از سبد خرید کاربران ایرانی کوتاه کنند.</p><p>گوشی‌های شیائومی به‌دلیل قیمت مقرون‌به‌صرفه در کنار ارائه‌ی قابلیت‌های جذاب، طی سال‌های اخیر محبوبیت زیادی بین کاربران ایرانی پیدا کرده‌اند. بسیاری از گوشی‌های شیائومی به‌لطف نمایشگر‌های کم‌حاشیه، متریال و کیفیت ساخت مناسب و پردازنده‌های پرقدرت حالا بیش‌ از هر وقت دیگری برای مدل‌های سامسونگ خط‌ونشان می‌کشند تا بیش‌از‌پیش دست برند محبوب کُره‌ای را از سبد خرید کاربران ایرانی کوتاه کنند.</p><p>گوشی‌های شیائومی به‌دلیل قیمت مقرون‌به‌صرفه در کنار ارائه‌ی قابلیت‌های جذاب، طی سال‌های اخیر محبوبیت زیادی بین کاربران ایرانی پیدا کرده‌اند. بسیاری از گوشی‌های شیائومی به‌لطف نمایشگر‌های کم‌حاشیه، متریال و کیفیت ساخت مناسب و پردازنده‌های پرقدرت حالا بیش‌ از هر وقت دیگری برای مدل‌های سامسونگ خط‌ونشان می‌کشند تا بیش‌از‌پیش دست برند محبوب کُره‌ای را از سبد خرید کاربران ایرانی کوتاه کنند.</p><a href='google.com'>گوگل</a><p>گوشی‌های شیائومی به‌دلیل قیمت مقرون‌به‌صرفه در کنار ارائه‌ی قابلیت‌های جذاب، طی سال‌های اخیر محبوبیت زیادی بین کاربران ایرانی پیدا کرده‌اند. بسیاری از گوشی‌های شیائومی به‌لطف نمایشگر‌های کم‌حاشیه، متریال و کیفیت ساخت مناسب و پردازنده‌های پرقدرت حالا بیش‌ از هر وقت دیگری برای مدل‌های سامسونگ خط‌ونشان می‌کشند تا بیش‌از‌پیش دست برند محبوب کُره‌ای را از سبد خرید کاربران ایرانی کوتاه کنند.</p>",
        //         suggest:[
        //             {
        //                 title : "عنوان وبلاگ",
        //                 cover : "/image/blogCover.jpg",
        //                 url : "/blog/read_more_about_guitar",
        //                 body : "خلاصه مختصر وبلاگ",
        //             },
        //             // تعداد مقالات 3 تا باشد
        //         ],
        //         catList : [
        //             {
        //                 name:"گیتار",
        //                 cat : "guitar"
        //             },
        //         ],
        //         totalRate : 4.25,
        //         totalRateNumber : 25 ,
        //         commentsList : [
        //             {
        //                 userName : "کاربر",
        //                 rate : 5,
        //                 comment : "نظر",
        //                 adminAnswer : "پاسخ"
        //             },
        //         ],
        //         commentsTotalNumber : 5
        //     });
        //     setLoading(false);
        // }, 5000);
    }, []);
    function fetchData(){
        const data = new FormData();
        data.append("ID", params.name);
        fetch("https://web.bamamiresi.com/Enrollment/GetPost",{
            method:"POST",
            body:data,
        })
        .then((res) => {
            if (!res.ok) {
            throw new Error("102");
            }
            return res.json();
        })
        .then((json) => {
            if (json.error) {
                throw new Error(json.msg);
            }
            console.log(json[0]);
            setData(json[0]);
            // setData({...data , 
            //     catList : [
            //         {
            //             name:"گیتار",
            //             cat : "guitar"
            //         },
            //     ],
            //     totalRate : 4.25,
            //     totalRateNumber : 25 ,
            //     commentsList : [
            //         {
            //             userName : "کاربر",
            //             rate : 5,
            //             comment : "نظر",
            //             adminAnswer : "پاسخ"
            //         },
            //     ],
            //     commentsTotalNumber : 5
            // });
            setLoading(false);
        })
        .catch((err) => {
            // navigate("/505");
            console.log(err);
        });
    }
    return <>
        {
            loading ? <section className="flex flexCol container blogDetailsLoadingSection">
                <div className="flex flexCol blogNavLoading rel">
                    <div className="loaderItem"></div>
                </div>
                <div className="flex flexCol loadingBlogInfo rel">
                    <div className="loaderItem"></div>
                </div>
                <div className="flex flexCol loadingBlogContent rel">
                    <div className="loaderItem"></div>
                </div>
            </section> : <>
            <NavsList data={[{name:"مقالات",link:"/blogs"},{name:data.title,link:""}]} />
            <main className="blogMainContent grid container ">
                <section className="blogMainRightDiv flex flexCol">
                    <div className="grid blogDetailsInfo">
                        <img src={data.cover} alt={data.title} className="blogMainImg" draggable="false" width={"100%"}/>
                        <div className="flex flexCol blogDetailsInfoDiv">
                            <h1 className="faFont textSize14 textClr3 blogTitle">
                                {
                                    data.title
                                }
                            </h1>
                            <p className="faFont textSize1 textClr7 blogShortDesc">
                                {
                                    data.shortDesc
                                }
                            </p>
                            <div className="flex blogIconDiv">
                                <p className="faFont textSize1 blogIconItem flex alignCenter">
                                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1.2em" width="1.2em" xmlns="http://www.w3.org/2000/svg"><path d="M6.445 12.688V7.354h-.633A13 13 0 0 0 4.5 8.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23"></path><path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z"></path><path d="M2.5 4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5z"></path></svg>
                                    {
                                        data.date
                                    }
                                </p>
                                <p className="faFont textSize1 blogIconItem flex alignCenter">
                                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M12 6a9.77 9.77 0 0 1 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0 1 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5a2.5 2.5 0 0 1 0 5 2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"></path></svg>
                                    {
                                        data.visit
                                    }
                                </p>
                                <p className="faFont textSize1 blogIconItem flex alignCenter">
                                    <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M20 2H4c-1.103 0-2 .897-2 2v18l5.333-4H20c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zm0 14H6.667L4 18V4h16v12z"></path></svg>
                                    {
                                        data.commentNumber
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="flex flexCol blogsContent">
                        <div className="flex flexCol blogContentList faFont content rel">
                            {
                                MyComponent({htmlContent:data.Contents})
                            }
                        </div>
                    </div>
                    <div className="flex alignCenter justifyBetween shareDiv">
                        <p className="faFont textSize1 textClr3">
                            اشتراک گذاری مطلب
                        </p>
                        <div className="flex alignCenter gap5">
                            <a href={"whatsapp://send?text="+window.location.href} className="textSize11 textClr5 flex flexCenter shareSocailItem">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1.1em" width="1.1em" xmlns="http://www.w3.org/2000/svg"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg>
                                <span className="hideText">share whatsapp</span>
                            </a>
                            <a href={"https://telegram.me/share/url?url="+window.location.href} className="textSize11 textClr5 flex flexCenter shareSocailItem ">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"></path></svg>
                                <span className="hideText">share telegram</span>
                            </a>
                            <a href={"https://twitter.com/share?url="+window.location.href} className="textSize11 textClr5 flex flexCenter shareSocailItem">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 2H1L9.26086 13.0145L1.44995 21.9999H4.09998L10.4883 14.651L16 22H23L14.3917 10.5223L21.8001 2H19.1501L13.1643 8.88578L8 2ZM17 20L5 4H7L19 20H17Z"></path></svg>
                                <span className="hideText">share twitter</span>
                            </a>
                            <a href={"https://www.linkedin.com/shareArticle?mini=true&url=="+window.location.href} className="textSize11 textClr5 flex flexCenter shareSocailItem">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 448 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path></svg>
                                <span className="hideText">share linkedin</span>
                            </a>
                            <a href={"https://www.facebook.com/sharer/sharer.php?u="+window.location.href} className="textSize11 textClr5 flex flexCenter shareSocailItem">
                                <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 320 512" height=".95em" width=".95em" xmlns="http://www.w3.org/2000/svg"><path d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"></path></svg>
                                <span className="hideText">share facebook</span>
                            </a>
                        </div>
                    </div>
                </section>
                <section className="flex flexCol blogMainLeftDiv">                        
                        {
                            data.catList &&  data.catList.length > 0 && 
                            <div className="flex flexCol tagsDiv">
                                <h4 className="faFont textSize11 textClr3">
                                    تگ های مقاله :
                                </h4>
                                <div className="flex blogCatsList">
                                    {
                                        data.catList.map((item,index)=>{
                                            return <Link to={`/blogs/?cats=${item.cat}`} className="faFont textSize9 textClr3 flex alignCenter suggestCatItem" key={index}>
                                                <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" aria-hidden="true" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14"></path></svg>
                                                {
                                                    item.name
                                                }
                                            </Link>
                                        })
                                    }
                                </div>
                            </div>
                        }
                    <div className="flex flexCol suggestBlogsDiv">
                        {
                            data.relatedPosts && data.relatedPosts.length > 0 &&
                            <>
                                <h3 className="faFont textSize12 textClr3">
                                    مقالات مرتبط
                                </h3>
                                <div className="flex flexCol suggestBlogsList">
                                    {
                                        data.relatedPosts.map((item,index)=>{
                                            if(index < 5)
                                                return <div className="grid suggestBlogItem" key={index}>
                                                    <Link className="flex flexCol"  draggable="false" to={item.url}>
                                                        <img src={item.cover} alt={item.title} className="suggestBlogImage" draggable="false"/>
                                                    </Link>
                                                    <div className="flex flexCol suggestBlogInfoDiv">
                                                        <Link className="faFont textSize11 textClr3 suggestBlogTitle" draggable="false" to={item.url}>
                                                            {
                                                                item.title
                                                            }
                                                        </Link>
                                                        <p className="faFont textSize9 textClr5 mar5">
                                                        {
                                                            cutText(item.Abstract,80)
                                                        }
                                                        </p>
                                                    </div>
                                                </div>
                                        })
                                    }
                                </div>
                            </>
                        }
                    </div>
                    
                </section>
            </main>
            {
                data.commentsList && data.commentsList.length > 0 &&
                <Comment data={{totalRate:data.totalRate , totalRateNumber : data.totalRateNumber ,comments : data.commentsList ,totalComments : data.commentsTotalNumber}} />
            }
            </>
        }
    </>
}